module.exports = __webpack_public_path__ + "img/red-bag-bg.b259d4c7.png";